import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { PageHead } from "@/components/PageHead";
import { FundPicker } from "@/components/FundPicker";
import { SipWidget } from "@/components/SipWidget";
import { Glossary } from "@/components/Glossary";
import { GoalPlanner } from "@/components/GoalPlanner";
import { RentVsBuy } from "@/components/RentVsBuy";

export default function SipCalculator() {
  const [sp] = useSearchParams();
  const [tab, setTab] = useState(sp.get("tab") || "sip");
  useEffect(() => { if (sp.get("tab")) setTab(sp.get("tab")); }, [sp]);
  const [fund, setFund] = useState({ code: "122639", name: "Parag Parikh Flexi Cap Fund" });
  return (
    <div data-testid="sip-page">
      <PageHead eyebrow="Calculators · Real NAV history" title="Plan it. Back-test it." sub="Replay a SIP or lumpsum on a fund's actual AMFI NAVs, or work out the monthly SIP your goal needs." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <div className="inline-flex rounded-xl bg-slate-200/70 p-1">
          {[["sip", "SIP vs Lumpsum"], ["goal", "Goal planner"], ["rvb", "Rent vs Buy"]].map(([k, l]) => <button key={k} data-testid={`calc-tab-${k}`} onClick={() => setTab(k)} className={`h-10 px-5 rounded-lg text-sm font-bold ${tab === k ? "bg-white shadow" : "text-slate-500"}`}>{l}</button>)}
        </div>
        {tab === "rvb" ? <RentVsBuy /> : tab === "goal" ? <GoalPlanner /> : <>
        <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm">
          <p className="font-display font-bold text-lg mb-4">Choose a fund</p>
          <FundPicker onPick={(code, f) => setFund({ code, name: f?.name })} />
          <p data-testid="sip-selected-fund" className="mt-4 text-sm">Selected: <Link to={`/mutual-funds/${fund.code}`} className="font-bold text-[#059669]">{fund.name}</Link></p>
        </div>
        <SipWidget code={fund.code} name={fund.name} />
        </>}
        <Glossary set={tab === "goal" ? "goal" : tab === "rvb" ? "realestate" : "sip"} />
      </div>
    </div>
  );
}
